import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import selected from './selected';
import translations from './lang/translations';
export default class InsertBackgroundScorm extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const { t } = editor.locale;
        editor.ui.componentFactory.add( 'InsertBackgroundScorm', locale => {
            const dropdownView = createDropdown( locale );

            // Populate the list in the dropdown with items.
            addListToDropdown( dropdownView, this.getDropdownItemsDefinitions( ['insert','remove'], [t('Insert background image'), t('Remove background image')]) );
            dropdownView.buttonView.set( {
                // The t() function helps localize the editor. All strings enclosed in t() can be
                // translated and change when the language of the editor changes.
                label: t( 'Background Image' ),
                icon: imageIcon,
                tooltip: true,
                withText: true
            } );

            // Callback executed once the image is clicked.
            dropdownView.on( 'execute', (evt) => {
                if(evt.source.commandParam == 'insert'){
                    this.insertBackgroundImage(this.editor);
                }else if(evt.source.commandParam == 'remove'){
                    this.removeBackgroundImage(this.editor);
                }
            } );

            return dropdownView;
        } );
    }
    getDropdownItemsDefinitions( commands, labels ) {
        const itemDefinitions = new Collection();

        for (let i = 0; i<commands.length; i++) {
            const definition = {
                type: 'button',
                model: new Model( {
                    commandParam: commands[i],
                    label: labels[i],
                    withText: true
                } )
            };
            // Add the item definition to the collection.
            itemDefinitions.add( definition );
        }

        return itemDefinitions;
    }
    insertBackgroundImage(currentEditor){
        let selectedItems = [];
        let editor = this.editor;
        const { t } = editor.locale;
        $.ajax({
            url: '/admin/media/internal',
            type: 'post',
            data: {
                type: 'Groups',
                id: 'internal',
            },
            success: function(response){
                // Add response in Modal body
                sessionStorage.setItem('background_image', 'true');
                let modalContent = document.createElement('div');
                modalContent.classList.add('image-picker-container');
                if(response.length == 0){
                    modalContent.innerText = t('Internal media storage is empty.');
                }
                for (let i=0; i<response.length; i++){
                    let container = document.createElement('div');
                    container.classList.add('image-picker-item');
                    container.dataset.href = response[i].url;
                    let image = document.createElement('img');
                    image.classList.add('image-picker-image');
                    image.src = response[i].url;
                    let name = document.createElement('p');
                    name.classList.add('image-picker-name');
                    name.innerText = response[i].name;
                    name.title = response[i].name;
                    container.append(image);
                    container.append(name);
                    modalContent.append(container);
                }
                $('.image_picker_modal-body').html(modalContent);

                let containers = document.querySelectorAll('.image-picker-item');
                if(containers){
                    for (let i=0;i<containers.length;i++){
                        containers[i].addEventListener('click', function (e) {
                            const imageUrl = this.dataset.href;
                            const fileName = imageUrl.split('/').pop();
                            const mediaToolId = window.mediaToolId || window.media_tool_id;

                            if (!mediaToolId) {
                                alert('Authoring tool media target is missing.');
                                return;
                            }

                            $.ajax({
                                url: '/admin/authoring/tool/upload-image',
                                type: 'POST',
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                },
                                data: {
                                    image_url: imageUrl,
                                    file_name: fileName,
                                    media_tool_id: mediaToolId
                                },
                                success: function (res) {
                                    const uploadedUrl = res.url;
                                    sessionStorage.setItem('save_images', 'true');
                                    sessionStorage.setItem('selected_item', JSON.stringify([uploadedUrl]));
                                    $('#image_picker_modal').modal('hide');
                                },
                                error: function () {
                                    alert('Image upload failed.');
                                }
                            });
                        }, false);
                    }
                }

                // Display Modal
                $('#image_picker_modal').modal('show');


                $('#image_picker_modal').on('hidden.bs.modal', function (e) {

                    // do something...
                    let saveImages = sessionStorage.getItem('save_images');
                    let backgroundImage = sessionStorage.getItem('background_image');
                    if(saveImages != 'true'){
                        sessionStorage.removeItem('save_images');
                        sessionStorage.removeItem('selected_item');
                        sessionStorage.removeItem('background_image');
                        selectedItems = [];
                        return;
                    }
                    let selectedImages = JSON.parse(sessionStorage.getItem('selected_item'));
                    if(selectedImages && saveImages == 'true' && backgroundImage == 'true'){
                        let orientation = sessionStorage.getItem('certificate_orientation') ? sessionStorage.getItem('certificate_orientation') : 'portrait';
                        let backgroundWidth = orientation == 'portrait' ? '3200px' : '4492px';
                        let backgroundHeight = orientation == 'portrait' ? '4492px' : '3200px';
                        if(sessionStorage.getItem('certificate_size') == 'card'){
                            backgroundWidth = '1012px';
                            backgroundHeight = '638px';
                        }
                        let html = editor.getData();
                        let url = selectedImages[0];
                        url = "background-image: url('"+url+"')";
                        let new_html = '<div id="background-image" style="'+url+'; background-size: contain; background-repeat: no-repeat; margin: 0;width:' + backgroundWidth + ';height:' + backgroundHeight + ';max-height: 100%;max-width: 100%;background-repeat: no-repeat;padding-top: 1px;position: absolute; left:0; top: 0;"><p>&nbsp;</p>' + html + '</div>';
                        editor.setData(new_html);
                        sessionStorage.removeItem('selected_item');
                        sessionStorage.removeItem('save_images');
                        sessionStorage.removeItem('background_image');
                        editor.model.change( writer => {
                            const insertPosition = editor.model.document.selection.getFirstPosition();
                            writer.insertText('.', {class: 'invisible'}, insertPosition);
                        } );

                        selectedItems = [];
                    }
                    let newModal = document.querySelector('#image_picker_modal').cloneNode(true);
                    $(this).remove();
                    document.body.appendChild(newModal);
                });
            }
        });
    }

    removeBackgroundImage(editor){
        let editorSourceId = editor.sourceElement.id;
        let container = document.querySelectorAll('#background-image');
        if(editorSourceId == 'content_back'){
            container = container[1];
        }else{
            container = container[0];
        }
        if(container){
            let html = container.innerHTML;
            editor.setData(html);
            editor.updateSourceElement();
        }
    }
}
